import { FC, ReactNode } from 'react'
import { composeClasses } from '@/utils/compose-classes'
import { Carousel, CarouselProps } from './carousel'
import 'swiper/css/bundle'

export interface ImageCarouselProps extends CarouselProps {
  bottomComponents?: ReactNode
  positionBottomComponents?: string
  classNameContainer?: string
  positionTopButton?: string
  topButton?: ReactNode
}

export const ImageCarousel: FC<ImageCarouselProps> = ({
  bottomComponents,
  positionBottomComponents = 'bottom-3 left-3',
  classNameContainer,
  positionTopButton = 'top-3 right-3',
  topButton,
  ...restProps
}) => {
  return (
    <div
      data-testid="image-container"
      className={composeClasses(
        classNameContainer,
        'relative object-cover w-full h-full'
      )}
    >
      {topButton && (
        <div
          data-testid="container-top-button"
          className={composeClasses(positionTopButton, 'absolute z-1')}
        >
          {topButton}
        </div>
      )}
      <Carousel {...restProps} />
      {bottomComponents && (
        <div
          data-testid="container-bottom-components"
          className={composeClasses(
            positionBottomComponents,
            'absolute z-1 flex gap-1.5 flex-row items-center justify-start'
          )}
        >
          {bottomComponents}
        </div>
      )}
    </div>
  )
}

export default ImageCarousel
